<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="text-center">Reports</h3>
        </v-flex>
        <v-flex xs12>
          <v-card class="purple--text">
            <v-sheet class="v-sheet--offset mx-auto" color="cyan" elevation="12" max-width="calc(100% - 32px)">
              <v-sparkline :labels="vlabels" :value="vvalues" color="purple" line-width="2" padding="16" stroke-linecap="round" :smooth="2" label-size="3" auto-draw>
                <template v-slot:label="item" :title="item">
                  {{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>
            <v-card-title>
              <v-spacer></v-spacer>
              Visit per day
            </v-card-title>
          </v-card>
          <p class="text-center">-------------------</p>
        </v-flex>
        <v-flex xs12>
          <v-card class="red--text">
            <v-sheet class="v-sheet--offset mx-auto" color="red" elevation="12" max-width="calc(100% - 32px)">
              <v-sparkline :labels="rlabels" :value="rvalues" color="white" line-width="2" padding="16" stroke-linecap="round" :smooth="2" label-size="3" auto-draw></v-sparkline>
            </v-sheet>
            <v-card-actions>
              <v-spacer></v-spacer>
              Requests per day
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Reports'

  export default {
    name: 'Reports',
    layout,
    props: [
      'visits',
      'requests',
    ],
    metaInfo () {
      return {
        title: 'Reports',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        vlabels: [],
        vvalues: [],
        rlabels:[],
        rvalues: []
      }
    },
    methods: {
      initialize () {
        let visits = this.visits
        let requests = this.requests
        this.vvalues = []
        this.vlabels = []
        this.rvalues = []
        this.rlabels = []

        for (let i = 0; i < visits.length; i++) {
          const element = visits[i];
          this.vlabels.push(element.date)
          this.vvalues.push(element.count)
        }

        for (let j = 0; j < requests.length; j++) {
          const element = requests[j];
          this.rlabels.push(element.date)
          this.rvalues.push(element.count)
        }
      },
    },
    mounted () {
      this.initialize()
    },
    watch: {
      'visits': 'initialize',
      'requests': 'initialize',
    }
  }
</script>
